// removed by extract-text-webpack-plugin
module.exports = {"SendingAccountNew":"SendingAccountNew","SendingAccountTitle":"SendingAccountTitle","SendingAccountContent":"SendingAccountContent","SendingAccountLeft":"SendingAccountLeft","SendingAccountRight":"SendingAccountRight","SendingAccountSVG":"SendingAccountSVG","SendingAccountTextBox":"SendingAccountTextBox","SendingAccountTooltipWrapper":"SendingAccountTooltipWrapper","SendingAccountTooltip":"SendingAccountTooltip","IconInfo":"IconInfo","SendingAccountDropdown":"SendingAccountDropdown","AccountDropdown":"AccountDropdown","AccountDropdownForm":"AccountDropdownForm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/areas/Account/CashTransfer1/Common/SendingAccountNew/styles.scss
// module id = 2233
// module chunks = 10